import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import Slider from 'antd/lib/slider';
import { currencyFormatter } from '../../../../common/utils/helpers';

@translate()
export default class RemainingAmount extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    min: PropTypes.number.isRequired,
    max: PropTypes.number.isRequired,
    step: PropTypes.number.isRequired,
    value: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
  };

  state = {
    value: [],
  };

  componentDidMount() {
    this.setState({
      value: [this.props.min, this.props.max],
    });
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.value[0] !== nextProps.value[0] || this.state.value[1] !== nextProps.value[1]) {
      this.setState({
        value: [nextProps.value[0], nextProps.value[1]],
      });
    }
  }

  onChange = value => {
    this.setState({ value });
  };

  onAfterChange = ([remainingAmountMin, remainingAmountMax]) =>
    this.props.onChange({
      remainingAmountMin,
      remainingAmountMax,
    });

  render() {
    const { t, min, max, step } = this.props;
    const { value } = this.state;

    return (
      <div className="filter remaining-amount-filter slider-filter">
        <span>
          {t('Rozsah sumy do zaplnenia')} {currencyFormatter(value[0])} -{' '}
          {currencyFormatter(value[1])}
        </span>
        <Slider
          range
          min={min}
          max={max}
          step={step}
          value={value}
          tipFormatter={currencyFormatter}
          onChange={this.onChange}
          onAfterChange={this.onAfterChange}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/allocations/components/filters/RemainingAmount.js